<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
               <a-col :span="8">
                    <a-row :gutter="10">
                        <a-col :span="11">
                            <a-input v-model="keyword" placeholder="请输入关键词" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="add_model=true,info_add={class:'招标公告'},add_user_value=''" v-if="$Func.check_rank('bid_add')">添加标书</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('bid_add')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('bid_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
          title="添加标书"
          :width="750"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="add_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="add_model=false"
           v-if="$Func.check_rank('bid_add')"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-row :gutter="20">
                    <a-col :span="24">
						<a-form-model-item ref="title" prop="title" label="标题">
							<a-input v-model="info_add.title" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="20">
                    <a-col :span="24">
						<a-form-model-item ref="class" prop="class" label="分类">
							<!-- <a-input v-model="info_add.class" /> -->
						    <a-select v-model="info_add.class" style="width: 100%" placeholder="请选择分类">
						        <a-select-option value="招标公告">招标公告</a-select-option>
						        <a-select-option value="新闻资讯">新闻资讯</a-select-option>
						    </a-select>
						</a-form-model-item>
                    </a-col>
                </a-row>
				
                <a-row :gutter="20">
                    <a-col :span="24">
						<a-form-model-item ref="city" prop="city" label="所在城市">
							<a-input v-model="info_add.city" />
						</a-form-model-item>
                    </a-col>
                </a-row>				
				
                <a-form-model-item ref="content" prop="content" label="内容">
                    <AEditor
                        v-model="info_add.content"
                    />
                </a-form-model-item>
				
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="add_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
        <Pics />
    </div>
</template>

<script>
    import Func from '../../common/func';
    import Pics from '../../components/Pics';
    import AEditor from '../../components/AEditor';
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '创建管理员',
            dataIndex: 'admin',
            key: 'admin',
        },
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '分类',
            dataIndex: 'class',
            key: 'class',
        },
        {
            title: '所在城市',
            dataIndex: 'city',
            key: 'city',
        },
        {
            title: '浏览量',
            dataIndex: 'views',
            key: 'views',
            width: 110,
            sorter: true,
        },
        {
            title: '创建时间',
            dataIndex: 'created',
            key: 'created',
            width: 160,
        },
        {
            title: '修改时间',
            dataIndex: 'modified',
            key: 'modified',
            width: 160,
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 180,
            key:'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    let add_timeout;
    let update_timeout;
    let search_timeout;
    export default {
        name: 'Info',
        components: {AEditor,Pics},
        data(){
            return {				
                base_url:Func.api_url,
                pic_url:Func.pic_url,
				
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                // 排序状态（「浏览量」等表头排序用）
                sort_field:'',
                sort_order:'',
                tableData:[],
                loading:false,
                add_model:false,
                update_model:false,

                search_fetching: false,
                search_user_value:undefined,
                search_user_list:[],


                add_fetching: false,
                update_fetching: false,
                add_user_value:undefined,
                update_user_value:undefined,
                add_user_list:[],
                update_user_list:[],
                group_list:[],
                info_add:{
					class:"招标公告",
                },
                add_rules: {
                    title:[{ required: true, message: '标题不能为空', trigger: 'blur' }],
                    city:[{ required: true, message: '所在城市不能为空', trigger: 'blur' }],
                    content:[{ required: true, message: '内容不能为空', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
            show_pic(data){
                this.$PubSub.publish('show_pics',data);
            },
			
			picUpdateChange(info) {
			    let fileList = [...info.fileList];
			
			    // 2. read from response and show file link
			    fileList = fileList.map(file => {
			        if (file.response) {
			            // Component will show file.url as link
			            file.url = this.pic_url+file.response.url;
			        }
			
			        return file;
			    });
			
			    console.log(fileList);
			    this.info_update.pic = fileList;
			    this.info_add.pic = fileList;
			},
			beforeUpload(file) {
			    const isLt2M = file.size / 1024 / 1024 < 200;
			    if (!isLt2M) {
			        this.$message.error('请上传200M以内文件!');
			    }
			    return isLt2M;
			},
			
            //指定用户 begin
            searchUserSearch(keyword) {
                if (search_timeout) {
                    clearTimeout(search_timeout);
                    search_timeout = null;
                }
                search_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.search_user_list = res.info.list;
                    });
                }, 300);
            },
            searchUserChange(value) {
                this.search_user_value=value;
            },


            //指定用户 begin
            addUserSearch(keyword) {
                if (add_timeout) {
                    clearTimeout(add_timeout);
                    add_timeout = null;
                }
                add_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.add_user_list = res.info.list;
                    });
                }, 300);
            },
            addUserChange(value) {
                this.info_add.uid = value;
                this.add_user_value=value;
            },
            updateReferrerSearch(keyword) {
                if (update_timeout) {
                    clearTimeout(update_timeout);
                    update_timeout = null;
                }
                update_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.update_user_list = res.info.list;
                    });
                }, 300);
            },
            updateReferrerChange(value) {
                this.info_update.uid = value;
                this.update_user_value=value;
            },
            //指定用户 end
            change_filter(pagination, filters, sorter, extra){
                // 记录表头排序状态（antd：ascend / descend / undefined）
                if (sorter && sorter.order) {
                    this.sort_field = sorter.field || '';
                    this.sort_order = sorter.order === 'ascend' ? 'asc' : 'desc';
                } else {
                    this.sort_field = '';
                    this.sort_order = '';
                }
                // 点表头排序时回到第一页；翻页则保持当前页
                var action = extra && extra.action ? extra.action : '';
                this.get_data(action === 'sort' ? 1 : pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'bid.index',
                    // uid:this.search_user_value||'',
                    keyword: keyword,
                    // 排序（服务端白名单校验，空值走默认排序）
                    sort_field: this.sort_field || '',
                    sort_order: this.sort_order || '',
                    page: page
                },(res) => {
					if (res.error === 0) {
						this.tableData = res.info.list;
						var pagination={
							pageSize:10,
							total:res.info.foot.total,
							current:parseInt(res.info.foot.current)
						}
						this.page=pagination;
						this.loading = false
					} else {
						this.$message.error(res.info);
					}
                });
            },

            update_data(res){
                const item=JSON.parse(JSON.stringify(res));
                Func.url_get({
					action:'bid.find_data',
                    id:item.id
                },(res) => {
                    this.info_add = res.info;
                });
				this.add_model = true;
            },
            add_data(e){
                e.preventDefault();
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'bid.add_data',
                            ...this.info_add,
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },

            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'bid.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            goto_url(url,id){
                this.$router.push({
                    path:'/admin/'+url,
                    params:{
                        id:id
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
	.pics img{
	    max-width: 100px;
	    max-height: 100px;
	}
</style>